/* global gettext */

/**
 *
 */
(function (sculpteo) {
  "use strict";

  var config = (sculpteo.MaterialConfiguration = {});

  config.defaultMaterialMap = {
    pmma: "pmma,clear,3",
  };

  /**
	 * We still need to use that file. It is easier to keep it and just replace the config.materialMap by window.materialOptionMap
	  window.materialOptionMap is fill it in design/print/index.html
	 */
  config.materialMap = window.materialOptionMap;
  config.materialBetaMap = window.materialOptionMapGroup;

  if (document.getElementById("MATERIAL_OPTIONS_TRANSLATIONS")) {
    config.materialTranslations = JSON.parse(
      document.getElementById("MATERIAL_OPTIONS_TRANSLATIONS").textContent
    );
  }

  config.materialDescriptions = {};

  config.materialThumbnails = {
    // MDF
    standard: "mdf_standard",
    // Plywood
    okoume: "plywood_okoume",
    poplar: "plywood_poplar",
    ceiba: "plywood_poplar",
    // Acrylic (PMMA)
    clear: "pmma_clear",
    pmmablack: "pmma_black",
    opaquewhite: "pmma_opaquewhite",
    diffusewhite: "pmma_diffusewhite",
    mirroredwhite: "pmma_opaquewhite",
    translucentwhite: "pmma_translucentwhite",
    translucentblue: "pmma_translucentblue",
    translucentred: "pmma_translucentred",
    translucentyellow: "pmma_translucentyellow",
    translucentorange: "pmma_translucentorange",
    translucentfuschia: "pmma_translucentfuschia",
    translucentviolet: "pmma_translucentviolet",
    ledblue: "pmma_ledblue",
    ledred: "pmma_ledred",
    ledyellow: "pmma_ledyellow",
    ledorange: "pmma_ledorange",
    ledgreen: "pmma_ledgreen",
    ledfuschia: "pmma_ledfuschia",
    // POM
    natural: "pmma_diffusewhite",
    pomblack: "pmma_black",
    1: "lasercut_thickness_1",
    2: "lasercut_thickness_2",
    3: "lasercut_thickness_3",
    5: "lasercut_thickness_5",
    6: "lasercut_thickness_6",
    8: "lasercut_thickness_8",
    10: "lasercut_thickness_10",
  };
})((window.sculpteo = window.sculpteo || {}));
